import {
  aCategory,
  anInsight,
  anInsightPage,
  anInsightStatus,
  aTeamPage,
  mockInsightsListQueryOperationQuery,
} from '__generated__';

export const handlers = [
  mockInsightsListQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        insights: anInsightPage({
          objects: [
            anInsight({
              id: '0',
            }),
            anInsight({
              id: '1',
            }),
            anInsight({
              id: '2',
            }),
            anInsight({
              id: '3',
            }),
          ],
        }),
        insightStatuses: [anInsightStatus()],
        teams: aTeamPage(),
        categories: [aCategory()],
      })
    );
  }),
];
